module.exports = __webpack_public_path__ + "static/media/add-to-home-screen-bg.06bbfe06.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/add-to-home-screen-bg.png
// module id = 2043
// module chunks = 103